import { withNamespaces } from "react-i18next";
import { useDsrDeadlineWorkflow } from "../../hooks/useDsrDeadlineWorkflow";

const AwaitingRequesterBadge = ({ t, caseId }) => {
  const { isAwaitingRequester } = useDsrDeadlineWorkflow(caseId);

  if (!isAwaitingRequester) {
    return null;
  }

  return (
    <div className="dsr-awaiting-requester-badge">
      {t("Awaiting requester")}
    </div>
  );
};

export default withNamespaces()(AwaitingRequesterBadge);
